export default __webpack_public_path__ + "static/media/red-bubbles.bcce0d63.svg";